import { makeStyles, colors } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  statusIconBox: {
    width: 32,
    height: 32,
    borderRadius: 6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  statusIconAnswered: {
    backgroundColor: colors.green[50],
  },
  statusIconPending: {
    backgroundColor: colors.orange[50],
  },
  answeredIcon: {
    color: colors.green[600],
  },
  pendingIcon: {
    color: colors.orange[600],
  },
  expandedContent: {
    padding: theme.spacing(2),
  },
  questionTitle: {
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.primary.main,
    lineHeight: 1.4,
    marginBottom: theme.spacing(1),
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  alternativesContainer: {
    marginBottom: theme.spacing(2),
  },
  alternativeItem: {
    marginBottom: 4,
    borderRadius: 4,
    border: `1px solid ${colors.grey[200]}`,
    backgroundColor: theme.palette.common.white,
  },
  alternativeItemSelected: {
    backgroundColor: theme.palette.primary.light,
    borderColor: theme.palette.primary.main,
  },
  alternativeLabel: {
    margin: 0,
    padding: theme.spacing(0.75, 1),
    width: '100%',
  },
  alternativeText: {
    fontSize: 13,
    color: theme.palette.text.primary,
  },
  fieldsRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  },
  fieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputField: {
    flex: 1,
    '& .MuiOutlinedInput-root': {
      borderRadius: 4,
      fontSize: 13,
      height: '100%',
    },
    '& .MuiOutlinedInput-multiline': {
      height: '100%',
      alignItems: 'flex-start',
    },
    '& .MuiOutlinedInput-inputMultiline': {
      height: '100% !important',
      overflow: 'auto !important',
    },
  },
  fileUploadBox: {
    border: `1px dashed ${colors.grey[300]}`,
    borderRadius: 4,
    padding: theme.spacing(1.5),
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: colors.grey[50],
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 60,
  },
  fileUploadIcon: {
    color: colors.grey[400],
  },
  fileUploadText: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  uploadedFile: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 1),
    backgroundColor: colors.green[50],
    borderRadius: 4,
  },
  uploadedFileName: {
    fontSize: 12,
    color: colors.green[700],
    fontWeight: 500,
    flex: 1,
  },
  actionButton: {
    borderRadius: 4,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(0.75, 2),
  },
  answerChip: {
    backgroundColor: colors.green[100],
    color: colors.green[800],
    fontWeight: 500,
  },
  divider: {
    margin: theme.spacing(2, 0),
    backgroundColor: colors.grey[100],
  },
  toggleButton: {
    marginLeft: 'auto',
    flexShrink: 0,
  },
}))

export default styles
